






























































































































































































import { Vue, Component, Mixins } from "vue-property-decorator";
import moment from "moment";
import filesaver from "file-saver";
import MyList from "@/mixins/list";

import SelectStadium from "@/components/selectstadium.vue";

import OrderDetail from "../bill/detail.vue";

@Component({
  components: {
    OrderDetail,
    SelectStadium
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "payments/list";

  orderDetailModalVisible = false;

  paychannels: any[] = [];

  columns: any[] = [
    {
      title: "编号",
      dataIndex: "id"
    },
    { title: "头像", scopedSlots: { customRender: "avatar" } },
    {
      title: "用户名",
      scopedSlots: { customRender: "username" }
    },
    { title: "城市", dataIndex: "city_name" },
    { title: "场馆名称", dataIndex: "stadium_name" },
    { title: "类型", scopedSlots: { customRender: "type" } },
    { title: "充值金额（元）", scopedSlots: { customRender: "fee" } },
    { title: "余额", scopedSlots: { customRender: "balance" } },
    { title: "充值方式", dataIndex: "channel_name" },
    { title: "充值时间", dataIndex: "created_time" },
    { title: "状态", scopedSlots: { customRender: "is_pay" } },
    { title: "微信交易单号", dataIndex: "transaction_id" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  // 操作搜索栏的展开和折叠
  isFlag = false;

  mounted() {
    this.loadPaymentChannel();
    // this.searchData.trade_type = '2'
    this.loadData({
      trade_type: 2
    });
  }

  async loadPaymentChannel() {
    const res = await this.$store.dispatch("bill/getPayChannels", {});
    if (res && res.Data) {
      this.paychannels = res.Data;
    }
  }

  async exportExcel() {
    this.$confirm({
      title: "确认信息",
      content: "确认导出吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("payments/export", {
          ...this.reloadQueryData
        });
        // console.log(res)
        if (res && res.data) {
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          filesaver.saveAs(blob, `充值记录${moment().format("YYYY-MM-DD HH:mm:ss")}.xlsx`);
        }
      }
    });
  }

  showOrderDetailModal(id: number) {
    this.editId = id;
    this.orderDetailModalVisible = true;
  }

  hideOrderDetailModal() {
    this.orderDetailModalVisible = false;
  }
}
